import { PlanCategoryEnum } from 'plan-library-common'
import {
  FilterOperationType,
  groupFieldsEnum,
  MAX_ELEVATIONS_PER_BASE_PLAN,
} from 'src/lib/constants'

import {
  GET_FILTERED_MULTI_FAMILY_DETAILS,
  GET_FILTERED_PLAN_DETAILS,
} from '../../lib/api-routes'
import { HttpResponse, instance } from '../../lib/axiosInstance'
import { IFilteredPlansRequest } from '../../types/filterPlans.interfaces'

export interface GetPlanDetailsParams {
  basePlanId: string
  division: string | undefined
  filters?: IFilteredPlansRequest
  groupBy: groupFieldsEnum
  plan: string
  planCategory: PlanCategoryEnum
  submitted: boolean
}

export interface GetMultiFamilyDetailsParams {
  basePlanId: string
  classType: string
  division: string | undefined
  groupBy: groupFieldsEnum
  plan: string
  planCategory: PlanCategoryEnum
}

export const getPlanDetails = async (
  params: GetPlanDetailsParams
): Promise<HttpResponse | undefined> => {
  try {
    const { basePlanId, division, groupBy, plan, planCategory } = params
    const endpoint = GET_FILTERED_PLAN_DETAILS(
      basePlanId,
      plan,
      planCategory,
      groupBy,
      division
    )

    const requestBody: IFilteredPlansRequest = params.filters || {
      currentPage: 1,
      filters: {
        basePlan: {
          operation: FilterOperationType.EQUALS,
          value: params.basePlanId,
        },
      },
      pageSize: MAX_ELEVATIONS_PER_BASE_PLAN,
      submitted: params.submitted,
    }

    return await instance.post(endpoint, requestBody)
  } catch (error) {
    return undefined
  }
}

export const getMultiFamilyDetails = async (
  params: GetMultiFamilyDetailsParams
): Promise<HttpResponse | undefined> => {
  const { basePlanId, classType, division, groupBy, plan, planCategory } =
    params

  const endpoint = GET_FILTERED_MULTI_FAMILY_DETAILS(
    classType,
    basePlanId,
    plan,
    planCategory,
    groupBy,
    division
  )
  return await instance.post(endpoint)
}
